import { Injectable, inject } from '@angular/core';

import { SessionService } from '../services';

@Injectable({
    providedIn: 'root'
})
export class TranslationService {
    private readonly sessionService = inject(SessionService);


    public init(): Promise<boolean> {
        return new Promise(resolve => {
            this.sessionService.SetLanguage().subscribe(() => resolve(true));
        });
    }
}
